export default "__VITE_ASSET__Yan5$iBD__"